import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { FormatRupiah } from '@arismun/format-rupiah';
import Topbar from '../layout/Topbar';
import Navbar from '../layout/Navbar';
import ItemTransaction from './ItemTransaction';
import { useBookStore } from '../../provider/BookStore';
import PeriodePicker from './PeriodePicker';
import dayjs from '../../utils/dayjs';
import { hitungPeriode, applyWeeklyStart } from '../../utils/periode';
import { hitungSummary } from '../../utils/statistik';
import { useTransactionStore } from '../../provider/TransactionStore';
import { RotatingLines } from 'react-loader-spinner';

const Transaction = (props) => {
    const navigate = useNavigate();

    const [summary, setSummary] = useState([]);
    const [transRaw, setTransRaw] = useState([]);
    const [trans, setTrans] = useState([]);

    const [date, setDate] = useState(dayjs());

    const [titleDate, setTitleDate] = useState('Aug')
    const [isLoading, setLoading] = useState(false);

    const [query, setQuery] = useState('')

    const bookState = useBookStore();
    const book = bookState.book;

    // cache transaksi bersama dengan halaman Statistik
    const transStore = useTransactionStore();

    useEffect(() => {
        console.log('bookState ' + bookState.book)
        if (book.id === undefined) {
            navigate('/')
        }

        // set default week start day
        applyWeeklyStart(book.weekly_start);

        setPeriode(0)
    }, []);

    const getTransactions = async (start, end) => {
        setLoading(true)
        // ambil dari cache store bila sudah pernah di-fetch periode ini
        const transc = await transStore.getTransactions(book.id, start, end);

        setSummary(hitungSummary(transc));
        setTransRaw(transc);

        const grouped = groupBy(transc, trs => trs.date)
        setTrans(grouped);

        setLoading(false)
    }

    const addTransaction = () => {
        navigate('/transaction/add');
    }

    const groupBy = (list, keyGetter) => {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        const array = Array.from(map, ([date, value]) => ({ date, value }));
        return array;
    }

    const setPeriode = (add) => {

        const { start, end, title, date: d } = hitungPeriode(book, date, add);

        if (d) {
            setDate(d);
        }
        setTitleDate(title);

        getTransactions(start, end);
    }

    const handlePeriodePrev = () => {
        console.log('previous')
        setPeriode(-1)
    }
    const handlePeriodeNext = () => {
        console.log('next')
        setPeriode(1)
    }

    const handleDelete = (listRaw) => {
        // data sudah berubah di server -> buang cache buku ini
        transStore.invalidate(book.id);
        const grouped = groupBy(listRaw, trs => trs.date);
        setTrans(grouped);

    }

    const handleSearch = (query) => {
        setQuery(query)
        const filteredCategory = transRaw.filter((tran) =>
            tran.category.toLowerCase().includes(query.toLowerCase())

        )

        const filteredNotes = transRaw.filter((tran)=>
            tran.note.toLowerCase().includes(query.toLowerCase())
        )
        //console.log(filteredTrans)

        Array.prototype.push.apply(filteredCategory,filteredNotes);

        const filteredTrans = new Set(filteredCategory)

        const grouped = groupBy(filteredTrans, trs => trs.date)
        setTrans(grouped)
    }

    return (
        <div>
            <Topbar
                page={'transaksi'}
                title={bookState.book.title}
                back={() => navigate('/')}
                isLoading={isLoading}
            />
            <div className='container p-5'>
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <button className='is-floating-fab has-background-primary has-text-white' onClick={() => addTransaction()}>
                            <i className="fa fa-plus"></i>
                        </button>

                        <div className="control  has-icons-right">
                            <input className="input" type="email" placeholder="Search" 
                                value={query} onChange={(e) => handleSearch(e.target.value)} />
                            
                            <span className="icon is-small is-right is-clickable" onClick={()=>handleSearch('')}>
                                <i className="fa fa-times"></i>
                            </span>
                        </div>

                        <PeriodePicker
                            periode={book.display}
                            periodeTitle={titleDate}
                            onPrev={handlePeriodePrev}
                            onNext={handlePeriodeNext}
                        />

                        {/* Tabel summary */}
                        <div className='card'>
                            <div className='card-header'>
                                <p className='card-header-title'>Ringkasan</p>
                            </div>
                            <div className='card-content'>

                                <div className='is-clearfix'>
                                    <p className='is-pulled-left'>Masuk</p>
                                    <p className='is-pulled-right'><FormatRupiah value={summary.debit} /></p>
                                </div>
                                <div className='is-clearfix'>
                                    <p className='is-pulled-left'>Keluar</p>
                                    <p className='is-pulled-right'>-<FormatRupiah value={summary.kredit} /></p>
                                </div>
                                <div className='is-clearfix'>
                                    <p className='is-pulled-left'>Saldo</p>
                                    <p className='is-pulled-right'><FormatRupiah value={summary.saldo} /></p>
                                </div>

                            </div>
                        </div>

                        {/* item transactions */}
                        <div className='mb-6'>
                            {trans.map((item, index) => (

                                <ItemTransaction
                                    key={index}
                                    date={item.date}
                                    listRaw={transRaw}
                                    transactions={item.value}
                                    onDelete={(list) => handleDelete(list)}
                                />

                            ))}
                        </div>


                    </div>
                </div>
            </div>

            <Navbar />

        </div>
    )
}

export default Transaction
